import type { CreateTeamDtoSchema, TeamSchema, UpdateTeamDtoSchema } from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const teamsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getTeams: builder.query<TeamSchema[], { departmentId?: string } | void>({
            query: (params) => ({
                url: "teams",
                params: params ?? {},
            }),
            providesTags: ["Team"],
        }),
        createTeam: builder.mutation<TeamSchema, CreateTeamDtoSchema>({
            query: (body) => ({ url: "teams", method: "POST", body }),
            invalidatesTags: ["Team"],
        }),
        updateTeam: builder.mutation<TeamSchema, { id: string; data: UpdateTeamDtoSchema }>({
            query: ({ id, data }) => ({ url: `teams/${id}`, method: "PATCH", body: data }),
            invalidatesTags: ["Team"],
        }),
        deleteTeam: builder.mutation<void, string>({
            query: (id) => ({ url: `teams/${id}`, method: "DELETE" }),
            invalidatesTags: ["Team"],
        }),
    }),
});

export const { useGetTeamsQuery, useCreateTeamMutation, useUpdateTeamMutation, useDeleteTeamMutation } = teamsApi;
